import { Controller } from "@hotwired/stimulus"

// Minimal tab switcher: tab buttons and panels are paired by data-key.
// Markup marks the initial state (one .active tab, other panels hidden).
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const key = event.currentTarget.dataset.key
    this.tabTargets.forEach((tab) => tab.classList.toggle("active", tab.dataset.key === key))
    this.panelTargets.forEach((panel) => (panel.hidden = panel.dataset.key !== key))
  }
}
